module.exports = __webpack_public_path__ + "static/media/success-dark.b81f136c.webp";